import React, { createContext, useContext, useState, useEffect } from 'react';

import { BrowserRouter as Router, Routes, Route, useLocation, useNavigationType, Navigate, useParams } from 'react-router-dom';

import "./lib/toast";
import { ToastContainer, toast, Slide } from "react-toastify";

//import 'react-toastify/dist/ReactToastify.css';
import Banner from './components/Banner';
import FullNavigator from './components/FullNavigator';
//import Navigator from './components/Navigator';
//import SubNav from './components/SubNav';
import Wrapper from './components/Wrapper';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import CommunityGuidelines from './pages/CommunityGuidelines';
import Maintenance from './components/Maintenance';
import LaunchCountdown from "./components/LaunchCountdown";
import Footer from './components/Footer';
import Home from './pages/Home';
import News from './pages/News';
import Guides from './pages/Guides';
import Article from './pages/Article';
import Values from './pages/Values';
import FurnitureDetail from './pages/FurnitureDetail';
import Player from './pages/Player';
import Imager from "./pages/Imager";
import Profile from './pages/Profile';
import StampShack from "./pages/StampShack";
import TopPosts from "./pages/TopPosts";
import FurniColor from "./pages/FurniColor";
import FontGenerator from "./pages/FontGenerator";
import FranklyWheel from "./pages/FranklyWheel";
import IAppreciateYou from "./pages/IAppreciateYou";
import WheelOverlay from "./pages/WheelOverlay";
import About from "./pages/About";
import Messages from './pages/Messages';
import { getHabboImageUrl } from './components/HabboImage';
import { getMaintenanceStatus, getCurrentUser, getBannerOffsets } from './services/api';
import { loadProfileSkins } from './data/profileSkins';
import { loadSiteTheme } from './data/siteTheme';
import { setFeatureFlags, useFeatureFlags } from './data/featureFlags';
import Inventory from './pages/members/settings/Inventory';
import Settings from './pages/members/settings/Settings';
import StampHistory from './pages/members/settings/StampHistory';
import ShopHistory from './pages/members/settings/ShopHistory';
import Gdpr from './pages/members/settings/Gdpr';
import ValueSubscriptions from './pages/members/settings/ValueSubscriptions';
import Statistics from './pages/members/settings/Statistics';
import PartnerUploadWidget from './pages/PartnerUploadWidget';
import Events from './pages/Events';
import LobbyBurst from './pages/games/LobbyBurst';
import SlimeSpins from './pages/games/SlimeSpins';
import FrankoPopShop from './pages/frankopop/FrankoPopShop';
import FrankoPopMyCollection from './pages/frankopop/FrankoPopMyCollection';
import FrankoPopActivity from './pages/frankopop/FrankoPopActivity';
import FrankoPopMarketplace from './pages/frankopop/FrankoPopMarketplace';
import FrankoPopMyTrades from './pages/frankopop/FrankoPopMyTrades';
import OriginsObserver from './pages/OriginsObserver';
//import ArtToolPage from './pages/ArtToolPage';
import ArticleCategoriesFilter from './pages/ArticleCategories';


import SulakeProImager from './pages/SulakeProImager';

import AskFrank from "./pages/AskFrank";
import FranklyNet from "./pages/FranklyNet";
import FranklyNetDoc from "./pages/franklynet/FranklyNetDoc";
import { isAskFrankHost } from "./components/franklynet/franklyNetHost";
import NotFound from "./pages/NotFound";
import StaffPanel from "./pages/staff/StaffPanel";
import FranklyStaffProImager from "./pages/staff/FranklyStaffProImager";
//import Easter2026 from './components/Easter2026';

export const FontScaleContext = createContext(1);

// TEMPORARY TOAST TEST
//import ToastTest from './pages/ToastTest';

const FURNI_API_URL = process.env.REACT_APP_FURNI_API_URL || "https://api.rhyss.dev/api/furni/latest";

// ─────────────────────────────────────────────────────────────────────────────
// TEMPORARY LOCAL DEV OVERRIDE
// ─────────────────────────────────────────────────────────────────────────────
const BYPASS_MAINTENANCE_LOCALLY = false;
const MAINTENANCE_BYPASS_ACTIVE =
    process.env.NODE_ENV === 'development' && BYPASS_MAINTENANCE_LOCALLY;

function pickRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

function parseSize(size) {
    const parts = (size || "1x1").split("x");
    const w = parseInt(parts[0], 10) || 1;
    const h = parseInt(parts[1], 10) || 1;
    return [w, h];
}

function flattenRotations(largeImages) {
    if (!Array.isArray(largeImages)) return [];
    const out = [];
    for (let i = 0; i < largeImages.length; i++) {
        const group = largeImages[i];
        if (!Array.isArray(group)) continue;
        for (let j = 0; j < group.length; j++) {
            if (group[j]) out.push(group[j]);
        }
    }
    return out;
}

function normaliseFurni(results, maxItems = Infinity, overrideByName = null) {
    if (!Array.isArray(results)) return [];
    const TILE_WIDTH = 64;
    const items = [];

    for (let i = 0; i < results.length && items.length < maxItems; i++) {
        const item = results[i];
        const name = (item?.name || "").trim();
        const nameKey = name.toLowerCase();

        const [w, h] = parseSize(item.size);
        const isSquare = w === h && w <= 3;
        const isOddSize = !isSquare && (w === 1 || h === 1);
        if (!isSquare && !isOddSize) continue;

        const rotations = flattenRotations(item.largeImages);
        if (!rotations.length) continue;

        const ov = overrideByName && nameKey ? overrideByName.get(nameKey) : null;

        const url = ov?.url
            ? ov.url
            : isSquare
                ? rotations[Math.floor(Math.random() * rotations.length)]
                : rotations[0];

        const tiles = Math.max(w, h);
        const offset = isOddSize && tiles > 1 ? ((tiles - 1) * TILE_WIDTH) / 2 : 0;

        items.push({
            id: item._id || item.name || i,
            name,
            url,
            size: item.size,
            type: item.type,
            stand: item.stand,
            createdAt: item.createdAt,
            lastUpdated: item.lastUpdated,
            offset,
            stateIndex: Number.isFinite(Number(ov?.stateIndex)) ? Number(ov.stateIndex) : undefined,
            rotationIndex: Number.isFinite(Number(ov?.rotationIndex)) ? Number(ov.rotationIndex) : undefined
        });
    }

    return items;
}

function LocationBackground({ children }) {
    const location = useLocation();
    const isStampShack = location.pathname === "/members/frampshack";

    return (
        <div
            className="min-h-screen bg-repeat bg-coal_dark"
            style={
                isStampShack
                    ? {
                        backgroundImage:
                            "linear-gradient(rgba(0,0,0,0.7), rgba(0,0,0,0.7)), url('/img/deepred.png')",
                        backgroundRepeat: "repeat, repeat",
                    }
                    : undefined
            }
        >
            {children}
        </div>
    );
}

function ScrollRestoration() {
    const location = useLocation();
    const navigationType = useNavigationType();
    const positions = React.useRef(new Map());

    React.useEffect(() => {
        const key = location.key;
        const handleScroll = () => positions.current.set(key, window.scrollY);

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, [location.key]);

    React.useEffect(() => {
        const y = positions.current.get(location.key) ?? 0;

        if (navigationType === "POP") {
            window.scrollTo(0, y);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location.key, navigationType]);

    return null;
}

function MemberProfileRoute({ userData, cloudUploadMode }) {
    const { username } = useParams();
    return <Profile key={username} userData={userData} cloudUploadMode={cloudUploadMode} />;
}

function HardRedirect({ to }) {
    useEffect(() => {
        const target = to || `${window.location.pathname}${window.location.search}`;
        window.location.replace(target);
    }, [to]);

    return null;
}

function HousekeepingRedirect() {
    const location = useLocation();
    const rest = location.pathname.replace(/^\/housekeeping/, '');
    const target = `/staff${rest ? `/admin${rest}` : ''}${location.search}`;

    return <HardRedirect to={target} />;
}

function App() {
    const featureFlags = useFeatureFlags();
    const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
    const [isLaunchCountdownMode, setIsLaunchCountdownMode] = useState(false);
    const [cloudUploadMode, setCloudUploadMode] = useState('all');
    const [isLoading, setIsLoading] = useState(true);
    const [userData, setUserData] = useState(null);
    const [furniItems, setFurniItems] = useState([]);
    const [habboConfig, setHabboConfig] = useState({
        Steve: { gesture: 'std' },
        Rhyss: { gesture: 'std' },
    });
    const [activeSection, setActiveSection] = useState('home');
    const [activePath, setActivePath] = useState('/');

    const FONT_SCALE_KEY  = 'frankly_font_scale';
    const FONT_SCALE_MIN  = 1.0;
    const FONT_SCALE_MAX  = 1.6;
    const FONT_SCALE_STEP = 0.1;
    const [fontScale, setFontScale] = useState(() => {
        try {
            const n = parseFloat(localStorage.getItem(FONT_SCALE_KEY));
            if (Number.isFinite(n) && n >= FONT_SCALE_MIN && n <= FONT_SCALE_MAX) return n;
        } catch {}
        return 1.0;
    });
    const adjustFontScale = (delta) => setFontScale(prev => {
        const next = Math.round((prev + delta) * 100) / 100;
        const clamped = Math.min(FONT_SCALE_MAX, Math.max(FONT_SCALE_MIN, next));
        try { localStorage.setItem(FONT_SCALE_KEY, String(clamped)); } catch {}
        return clamped;
    });

    useEffect(() => {
        const loadEverything = async () => {
            const themePromise = loadSiteTheme();

            try {
                const maintenanceResponse = await getMaintenanceStatus();
                const isMaintenance = !!maintenanceResponse.maintenance;
                const isLaunchCountdown = !!maintenanceResponse.launchCountdown;
                if (maintenanceResponse.cloudUploadMode) setCloudUploadMode(maintenanceResponse.cloudUploadMode);
                setFeatureFlags(maintenanceResponse.features);

                if (isMaintenance) {
                    let canBypass = false;
                    try {
                        const userResponse = await getCurrentUser();
                        if (userResponse.success && userResponse.user && userResponse.user.hasAdminRole) {
                            setUserData(userResponse.user);
                            canBypass = true;
                        }
                    } catch (error) {
                        // Treated as non-admin below.
                    }

                    if (canBypass) {
                        setIsMaintenanceMode(false);
                        setIsLaunchCountdownMode(false);
                    } else if (MAINTENANCE_BYPASS_ACTIVE) {
                        console.warn('[DEV] Maintenance bypass active — viewing site as logged-out visitor. Revert BYPASS_MAINTENANCE_LOCALLY before shipping.');
                        setIsMaintenanceMode(false);
                        setIsLaunchCountdownMode(false);
                    } else {
                        setIsMaintenanceMode(!isLaunchCountdown);
                        setIsLaunchCountdownMode(isLaunchCountdown);
                        setIsLoading(false);
                        return;
                    }
                } else {
                    try {
                        const userResponse = await getCurrentUser();
                        if (userResponse.success && userResponse.user) {
                            setUserData(userResponse.user);
                        }
                    } catch (error) {
                    }
                    setIsMaintenanceMode(false);
                    setIsLaunchCountdownMode(false);
                }

                const furniPromise = fetch(FURNI_API_URL, { cache: "no-store" })
                    .then(res => res.ok ? res.json() : null)
                    .then(data => data?.results || null)
                    .catch(() => null);

                const bannerOffsetsPromise = getBannerOffsets().catch(() => null);
                const skinsPromise = loadProfileSkins();

                const [furniResults, bannerOffsetsData] = await Promise.all([furniPromise, bannerOffsetsPromise, skinsPromise, themePromise]);

                const overrideByName = new Map();
                const rows = Array.isArray(bannerOffsetsData?.offsets)
                    ? bannerOffsetsData.offsets
                    : Array.isArray(bannerOffsetsData)
                        ? bannerOffsetsData
                        : [];

                for (let i = 0; i < rows.length; i++) {
                    const r = rows[i];
                    const furniName = (r?.furniName || r?.FurniName || "").trim();
                    const furniUrl = (r?.furniUrl || r?.FurniUrl || "").trim();
                    if (!furniName || !furniUrl) continue;

                    overrideByName.set(furniName.toLowerCase(), {
                        url: furniUrl,
                        stateIndex: Number.isFinite(Number(r?.stateIndex)) ? Number(r.stateIndex) : Number.isFinite(Number(r?.StateIndex)) ? Number(r.StateIndex) : 0,
                        rotationIndex: Number.isFinite(Number(r?.rotationIndex)) ? Number(r.rotationIndex) : Number.isFinite(Number(r?.RotationIndex)) ? Number(r.RotationIndex) : 0
                    });
                }

                let processedFurni = [];
                if (furniResults) {
                    processedFurni = normaliseFurni(furniResults, Infinity, overrideByName);
                }

                setFurniItems(processedFurni);

                const gestures = ['sml', 'srp'];
                const nextHabboConfig = {
                    Steve: { gesture: pickRandom(gestures) },
                    Rhyss: { gesture: pickRandom(gestures) },
                };

                setHabboConfig(nextHabboConfig);

            } catch (error) {
                // 429 = rate limited; show a friendly message, not the maintenance screen
                if (error.status === 429) {
                    toast.error('The server is busy right now. Please try again in a moment.', { autoClose: 8000 });
                } else {
                    console.error('Failed to connect to API:', error);
                    toast.error('Could not connect to server', { autoClose: 5000 });
                    setIsMaintenanceMode(true);
                }
            } finally {
                setIsLoading(false);
            }
        };

        loadEverything();
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const loginStatus = urlParams.get('login');
        const error = urlParams.get('error');

        if (loginStatus === 'success') {
            toast.success('Logged in!', {
                autoClose: 3000,
            });
            window.history.replaceState({}, document.title, window.location.pathname);
        } else if (error) {
            let errorMessage = 'Login failed';

            switch(error) {
                case 'no_code':
                    errorMessage = 'No auth code';
                    break;
                case 'not_verified':
                    errorMessage = "You're not verified with OriginsBot.";
                    break;
                case 'no_staff_role':
                    errorMessage = "You don't have staff access.";
                    break;
                case 'auth_failed':
                    errorMessage = 'Auth failed.';
                    break;
                default:
                    errorMessage = `Login failed: ${error}`;
            }

            toast.error(errorMessage, {
                autoClose: 5000,
            });
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }, []);

    const toastContainer = (
        <>
            <style>{`
                @media (max-width: 639px) {
                    .frankly-toast-container {
                        left: 50% !important;
                        right: auto !important;
                        bottom: auto !important;
                        top: 16px !important;
                        transform: translateX(-50%) !important;
                        width: auto !important;
                        max-width: 95vw !important;
                    }
                }
            `}</style>
            <ToastContainer
                position="bottom-center"
                newestOnTop
                closeButton={false}
                hideProgressBar
                autoClose={4500}
                transition={Slide}
                className="frankly-toast-container"
                toastClassName={() => "bg-transparent shadow-none p-0 m-0 border-0 rounded-none"}
                bodyClassName={() => "p-0 m-0"}
                style={{ left: "auto", right: 16, bottom: 0, transform: "none" }}
            />
        </>
    );

    if (window.location.pathname.startsWith('/franklycloud/widget')) {
        return (
            <Router>
                <Routes>
                    <Route path="/franklycloud/widget" element={<PartnerUploadWidget />} />
                </Routes>
            </Router>
        );
    }

    if (isLoading) {
        return (
            <div className="min-h-screen bg-coal_dark flex flex-col items-center justify-center">
                <div className="relative w-[250px] h-[250px] overflow-hidden">
                    <img
                        src={`${process.env.PUBLIC_URL}/img/frankly-ducks.gif`}
                        alt="Loading..."
                        className="absolute left-1/2 top-1/2 block"
                        style={{
                            transform: 'translate(-50%, -56%) translateX(-8px) scale(1)',
                            transformOrigin: 'center',
                            imageRendering: 'pixelated'
                        }}
                    />
                </div>

                <p className="mt-[-10px] text-white font-['Jersey_10'] text-[20px] uppercase text-center">
                    Frankly, we&apos;re just loading
                    <span className="inline-flex align-baseline">
                        <style>{`
                            @keyframes loadingDot {
                                0%, 20% { opacity: 0; }
                                30%, 100% { opacity: 1; }
                            }
                        `}</style>

                        <span style={{ animation: 'loadingDot 1s infinite', animationDelay: '0ms' }}>.</span>
                        <span style={{ animation: 'loadingDot 1s infinite', animationDelay: '200ms' }}>.</span>
                        <span style={{ animation: 'loadingDot 1s infinite', animationDelay: '400ms' }}>.</span>
                    </span>
                </p>
            </div>
        );
    }

    // Overlay route — transparent, no chrome. Checked before maintenance so live
    // overlays keep working even when the site is in maintenance mode.
    if (window.location.pathname.startsWith('/goodies/franklywheel/overlay')) {
        return (
            <Router>
                <Routes>
                    <Route path="/goodies/franklywheel/overlay" element={<WheelOverlay />} />
                </Routes>
            </Router>
        );
    }

    if (isMaintenanceMode) {
        return (
            <>
                {toastContainer}
                <Maintenance />
            </>
        );
    }

    const staffPath = window.location.pathname;
    const isStaffPanelPath = (staffPath === '/staff' || staffPath.startsWith('/staff/'))
        && !staffPath.startsWith('/staff/proimager');

    if (isStaffPanelPath) {
        return (
            <>
                {toastContainer}
                <Router>
                    <ScrollRestoration />
                    <StaffPanel userData={userData} furniItems={furniItems} />
                </Router>
            </>
        );
    }

    const isAdmin = userData?.hasAdminRole === true;
    const featureOn = (key) => featureFlags[key] || isAdmin;
    const featureRoute = (key, element) => (featureOn(key) ? element : <NotFound />);

    const askFrankHost = isAskFrankHost();
    const askFrankPath = window.location.pathname.startsWith('/askfrank')
        || window.location.pathname.startsWith('/franklynet');

    if (askFrankHost || askFrankPath) {
        if (!featureOn('askfrank')) {
            return (
                <>
                    {toastContainer}
                    <Router>
                        <div className="min-h-screen bg-coal_dark">
                            <NotFound />
                        </div>
                    </Router>
                </>
            );
        }

        return (
            <>
                {toastContainer}
                <Router>
                    <ScrollRestoration />
                    <Routes>
                        <Route path="/askfrank" element={<AskFrank />} />
                        <Route path="/askfrank/home" element={<FranklyNet />} />
                        <Route path="/askfrank/results" element={<FranklyNet />} />
                        <Route path="/askfrank/view" element={<FranklyNet />} />
                        <Route path="/askfrank/doc/:kind/:slug" element={<FranklyNetDoc />} />
                        <Route path="/franklynet" element={<FranklyNet />} />
                        <Route path="/franklynet/view" element={<FranklyNet />} />
                        <Route path="/franklynet/article/:slug" element={<FranklyNet />} />
                        <Route path="/franklynet/doc/:kind/:slug" element={<FranklyNetDoc />} />
                        {askFrankHost && <Route path="/" element={<AskFrank />} />}
                        {askFrankHost && <Route path="/home" element={<FranklyNet />} />}
                        {askFrankHost && <Route path="/view" element={<FranklyNet />} />}
                        {askFrankHost && <Route path="/doc/:kind/:slug" element={<FranklyNetDoc />} />}
                        <Route path="*" element={askFrankHost ? <FranklyNet /> : <AskFrank />} />
                    </Routes>
                </Router>
            </>
        );
    }

    return (
        <>
            {toastContainer}

            <Router>
                <ScrollRestoration />
                <LocationBackground>
                    <Banner furniItems={furniItems} habboConfig={habboConfig} />
                    { /* <Easter2026 userData={userData} /> */ }
                    <FullNavigator
                        userData={userData}
                        activeSection={activeSection}
                        setActiveSection={setActiveSection}
                        activePath={activePath}
                        setActivePath={setActivePath}
                        fontScale={fontScale}
                        onFontScaleUp={() => adjustFontScale(FONT_SCALE_STEP)}
                        onFontScaleDown={() => adjustFontScale(-FONT_SCALE_STEP)}
                        fontScaleMin={FONT_SCALE_MIN}
                        fontScaleMax={FONT_SCALE_MAX}
                    />
                    <FontScaleContext.Provider value={fontScale}>
                    <div style={{ zoom: fontScale, maxWidth: `calc(1400px / ${fontScale})`, margin: '0 auto', '--img-counter-zoom': 1 / fontScale }}>
                    <Wrapper>
                        <Routes>


                            <Route path="/" element={<Home userData={userData} />} />
                            <Route path="/news/all" element={<News />} />
                            <Route path="/article" element={<Article />} />
                            <Route path="/article/:dateSlug/:titleSlug" element={<Article userData={userData} />} />
                            <Route path="/articles" element={<ArticleCategoriesFilter />} />
                            <Route path="/articles/:categorySlug" element={<ArticleCategoriesFilter />} />
                            <Route path="/news/guides" element={<Guides userData={userData} />} />
                            <Route path="/events" element={<Events />} />
                            <Route path="/observer" element={featureRoute('observer', <OriginsObserver />)} />

                            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="/terms-of-service" element={<TermsOfService />} />
                            <Route path="/community-guidelines" element={<CommunityGuidelines />} />

                            <Route path="/goodies" element={<Home userData={userData} />} />
                            <Route path="/goodies/imager" element={featureRoute('imager', <Imager userData={userData} />)} />
                            {/* <Route path="/goodies/franklyart" element={<ArtToolPage />} /> */}
                            <Route path="/goodies/fontgenerator" element={featureRoute('fontgenerator', <FontGenerator />)} />
                            <Route path="/goodies/furnicolourer" element={featureRoute('furnicolourer', <FurniColor />)} />
                            <Route path="/goodies/franklywheel" element={featureRoute('franklywheel', <FranklyWheel />)} />
                            <Route path="/goodies/appreciate" element={featureRoute('appreciate', <IAppreciateYou userData={userData} />)} />

                            <Route path="/games/lobbyburst" element={featureRoute('lobbyburst', <LobbyBurst userData={userData} />)} />
                            <Route path="/games/slimeburgerspin" element={featureRoute('slimespins', <SlimeSpins userData={userData} />)} />

                            <Route path="/frankopop" element={featureRoute('frankopop', <Navigate to="/frankopop/shop" replace />)} />
                            <Route path="/frankopop/shop" element={featureRoute('frankopop', <FrankoPopShop userData={userData} />)} />
                            <Route path="/frankopop/my-collection" element={featureRoute('frankopop', <FrankoPopMyCollection userData={userData} />)} />
                            <Route path="/frankopop/activity" element={featureRoute('frankopop', <FrankoPopActivity userData={userData} />)} />
                            <Route path="/frankopop/marketplace" element={featureRoute('frankopop', <FrankoPopMarketplace userData={userData} />)} />
                            <Route path="/frankopop/trades" element={featureRoute('frankopop', <FrankoPopMyTrades userData={userData} />)} />

                            <Route
                                path="/members/profile"
                                element={
                                    userData
                                        ? <Navigate to={`/members/profile/${encodeURIComponent(userData.username || userData.habbo || userData.habboName || userData.name)}`} replace />
                                        : <Navigate to="/" replace />
                                }
                            />
                            <Route path="/members/profile/:username" element={<MemberProfileRoute userData={userData} cloudUploadMode={cloudUploadMode} />} />
                            <Route path="/members/frampshack" element={featureRoute('frampshack', <StampShack userData={userData} />)} />
                            <Route path="/members/stampshack" element={<Navigate to="/members/frampshack" replace />} />
                            <Route path="/members/topposts" element={featureRoute('topposts', <TopPosts userData={userData} />)} />

                            <Route path="/members/settings" element={<Settings userData={userData} />} />
                            <Route path="/members/settings/statistics" element={<Statistics userData={userData} />} />
                            <Route path="/members/settings/stamp-history" element={<StampHistory userData={userData} />} />
                            <Route path="/members/settings/shop-history" element={<ShopHistory userData={userData} />} />
                            <Route path="/members/settings/gdpr" element={<Gdpr userData={userData} />} />
                            <Route path="/members/settings/value-subscriptions" element={<ValueSubscriptions userData={userData} />} />
                            <Route path="/members/settings/inventory" element={<Inventory userData={userData} />} />

                            <Route path="/values" element={<Values />} />
                            <Route path="/furniture/:slug" element={<FurnitureDetail userData={userData} />} />
                            <Route path="/player/:hotel/:habboName" element={<Player />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/messages" element={<Messages userData={userData} />} />

                            <Route path="/housekeeping" element={<HousekeepingRedirect />} />
                            <Route path="/housekeeping/*" element={<HousekeepingRedirect />} />
                            <Route path="/staff/proimager" element={<FranklyStaffProImager userData={userData} />} />
                            <Route path="/staff" element={<HardRedirect />} />
                            <Route path="/staff/*" element={<HardRedirect />} />

                            <Route path="/sulakeproimager" element={<SulakeProImager userData={userData} />} />

                            {/* STEVE KEEP THIS LINK AT THE BOTTOM */}
                            <Route path="*" element={<NotFound />} />

                            {/*<Route path="/toasttest" element={<ToastTest />} />*/}
                        </Routes>
                    </Wrapper>
                    </div>
                    </FontScaleContext.Provider>
                    <Footer />
                </LocationBackground>
            </Router>
        </>
    );
}

export default App;